<template>
  <line
    :x1 ="getOffsetXLine"
    :y1 = "0"
    :x2 = "getOffsetXLine"
    :y2 = "getPipeEditorHeight"
    :style = "getLineColor"
  />
  <rect
    :x = "getOffsetX"
    y = "0"
    :width = "Math.max(getOffset + getXAxisGap, 0)"
    :height = "getPipeEditorHeight"
    fill = "white"
    fill-opacity=".5"
    class="offset-block"
  />
</template>

<script>
import { useSegmentStore } from '@/store/SegmentStore';
import { useInputStore } from '@/store/InputStore';

export default {
  name: 'Offset',
  data () {
    return {
      startCircleX: 0,
      startMouseX: 0
    };
  },
  props: [
    'side'
  ],
  computed : {
    getOffsetX () {
      return this.$props.side === 'left' ? 0 : ((useSegmentStore().getAllSegmentLengths('pipe') - useInputStore().getRightOffset) * this.getMagScale) + this.getXAxisGap;
    },
    getOffsetXLine () {
      const inputStore = useInputStore();
      return this.$props.side === 'left'
        ? (inputStore.getLeftOffset * this.getMagScale) + this.getXAxisGap
        : ((useSegmentStore().getAllSegmentLengths('pipe') - inputStore.getRightOffset) * this.getMagScale) + this.getXAxisGap;
    },
    getOffset () {
      const inputStore = useInputStore();
      const segmentStore = useSegmentStore();
      return this.$props.side === 'left'
        ? inputStore.getLeftOffset * this.getMagScale
        : (((segmentStore.getAllSegmentLengths('slope') - segmentStore.getAllSegmentLengths('pipe')) * this.getMagScale) + inputStore.getRightOffset) * this.getMagScale;
    },
    getXAxisGap () {
      return useInputStore().getXAxisGap;
    },
    getMagScale () {
      return useSegmentStore().getMagScale;
    },
    getPipeEditorHeight () {
      return useSegmentStore().getPipeEditorHeight;
    },
    getLineColor () {
      return 'stroke:rgb(0,0,0);stroke-width:1';
    }
  },
  methods: {
    handleMouseDown (e) {
      this.startCircleX = (this.$props.side === 'right') ? useSegmentStore().getOffset('right') : this.getOffset;
      this.startMouseX = e.clientX;
      document.body.addEventListener('mousemove', this.handleMouseMove);
      document.body.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseMove (e) {
      let offset = (this.startMouseX - (e.clientX));
      let newValue = this.startCircleX - offset;
      if (this.$props.side === 'right') {
       newValue = this.startCircleX + offset;
      }
      if (newValue < 0) { newValue = 0; }
      const segmentStore = useSegmentStore();
      segmentStore.setOffset(this.$props.side, newValue);
      segmentStore.setOffsetDragged(this.$props.side);
    },
    handleMouseUp () {
      document.body.removeEventListener('mousemove', this.handleMouseMove);
      document.body.removeEventListener('mouseup', this.handleMouseUp);
    },
  }
};
</script>

<style scoped>
.offset-circle {
  cursor: ew-resize;
}
.offset-block {
  pointer-events: none;
}
</style>